<template>
  <div>
    <CycleDetail :key="itemKey"></CycleDetail>
  </div>
</template>

<script>
import CycleDetail from "@/components/CycleDetail/index.vue";
export default {
  components: {
    CycleDetail,
  },
  data() {
    return {
      itemKey: 1,
    };
  },
  watch: {
    "$route.params": {
      deep: true,
      immediate: true,
      handler(data, oldData) {
        if (data.projectId == oldData?.projectId) return;
        this.itemKey += 1;
      },
    },
  },
};
</script>

<style></style>
